import { render, staticRenderFns } from "./EntwicklungContainer.vue?vue&type=template&id=4abb9e4d&"
import script from "./EntwicklungContainer.vue?vue&type=script&lang=js&"
export * from "./EntwicklungContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports